import { Grid, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, MenuItem, Card, CardHeader, CardContent } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import { useState, forwardRef, useImperativeHandle, useEffect } from "react"
import { CommonConstant } from "shared/constants/common-constant"
import { GlobalData } from "shared/global-data"

const InboundDeliveryPaperwork = forwardRef(({ deliveryInfo }, ref) => {
  const [packagingType, setPackagingType] = useState("Carton")
  const [location, setLocation] = useState("")
  const [quantity, setQuantity] = useState(1)
  const [despatchDate, setDespatchDate] = useState(new Date())
  const [deliveryDate, setDeliveryDate] = useState(new Date())
  const [addresses, setAddresses] = useState([])

  useEffect(() => {
    const defaultAddresses = ["Lot 23 Hollinsworth Road, Marsden Park, NSW, 2765", "9-10 John Morphett Place, Erskine Park, NSW, 2759"]
    const warehouse = deliveryInfo["warehouse"]
    let addressesData = GlobalData.FilterCriteria
      ? GlobalData.FilterCriteria.filter(filter => filter.FILTER_NAME === "WAREHOUSE" && filter.SYS_VALUE === warehouse).map(address => address.ADDRESS_DETAIL || address.EXTENDED_VALUE)
      : defaultAddresses
    if (!addressesData.length) {
      addressesData = defaultAddresses
    }

    if (addressesData.length == 1) setLocation(addressesData[0])

    setAddresses(addressesData)
  }, [])

  useImperativeHandle(ref, () => ({
    async getFormDataIfValid() {
      return {
        location,
        packagingType,
        quantity,
        despatchDate,
        deliveryDate,
      }
    },
  }))

  return (
    <Card>
      <CardHeader title="Paperwork" />
      <CardContent>
        <Grid container spacing={3} id="divToPrint">
          <Grid item md={3} xs={12}></Grid>
          <Grid item md={6} xs={12}>
            <TextField fullWidth required label="Select Delivery Location" select variant="outlined" value={location} onChange={event => setLocation(event.target.value)}>
              {addresses.map(address => (
                <MenuItem key={address} value={address}>
                  {address}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={3} xs={12}></Grid>

          <Grid item md={3} xs={12}></Grid>
          <Grid item md={6} xs={12} style={{ display: "flex", justifyContent: "center" }}>
            <FormControl>
              <FormLabel id="packagingType">Packaging Type</FormLabel>
              <RadioGroup row aria-labelledby="packagingType" name="packagingType" value={packagingType} onChange={event => setPackagingType(event.target.value)}>
                <FormControlLabel value="Carton" control={<Radio />} label="Carton" />
                <FormControlLabel value="Pallet" control={<Radio />} label="Pallet" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item md={3} xs={12}></Grid>

          <Grid item md={4} xs={12}></Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              type="number"
              label={`Number of ${packagingType === "Carton" ? "Cartons" : "Pallets"}`}
              variant="outlined"
              value={quantity}
              onChange={event => setQuantity(event.target.value)}
            />
          </Grid>
          <Grid item md={4} xs={12}></Grid>

          <Grid item md={4} xs={12}>
            <DatePicker
              format={CommonConstant.DATE_FORMAT}
              label="Despatch Date"
              value={despatchDate}
              onChange={val => setDespatchDate(val)}
              renderInput={props => <TextField fullWidth {...props} />}
            />
          </Grid>
          <Grid item md={4} xs={12}></Grid>
          <Grid item md={4} xs={12}>
            <DatePicker
              format={CommonConstant.DATE_FORMAT}
              label="Expected Delivery Date"
              value={deliveryDate}
              onChange={val => setDeliveryDate(val)}
              renderInput={props => <TextField fullWidth {...props} />}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
})

export default InboundDeliveryPaperwork
